import React, { useState, useEffect } from 'react';
import { List, Datagrid, TextField, TextInput, Filter, FunctionField, Show, SimpleShowLayout, ArrayField, NumberField, ReferenceField, RefreshButton, ShowButton, ReferenceManyField } from 'react-admin';
import { Create, SimpleForm, usePermissions } from 'react-admin';
import { GoogleMap, withScriptjs, withGoogleMap, Marker } from "react-google-maps"
import { cloneElement } from 'react';
import {
    useListContext,
    TopToolbar,
    CreateButton,
    ExportButton,
    EditButton,
    Edit,
    SaveButton,
    Toolbar,
    sanitizeListRestProps,
    SelectInput,
    ReferenceInput,
    required
} from 'react-admin';
import AddMachineButton from '../buttons/addMachineButton';
import CircleIcon from '@material-ui/icons/FiberManualRecord';
import EmptyCircleIcon from '@material-ui/icons/RadioButtonUnchecked';
import { Redirect } from 'react-router-dom';

const styles = {
    div1: {
        display: 'block',
        width: "25%",
        float: "left",
        position: "flex",
        marginRight: "10px"
    },
    div1Mobile: {
        display: 'block',
        width: "50%",
        float: "left",
        position: "flex",
        marginLeft: "2%",
        marginRight: "2%"
    },
    div2: {
        display: 'block',
        width: "74%",
        float: "left",
        position: "flex"
    },
    div2Mobile: {
        display: 'block',
        width: "100%",
        float: "left",
        marginLeft: "2%",
        marginRight: "2%",
        marginTop: "2%",
        position: "flex"
    },
    table: {
        overflowX: "auto"
    }
};

const ListActions = (props) => {
    const {
        className,
        exporter,
        filters,
        maxResults,
        ...rest
    } = props;
    const {
        currentSort,
        resource,
        displayedFilters,
        filterValues,
        basePath,
        showFilter,
        total,
    } = useListContext();
    const permissions = usePermissions().permissions;
    if (!permissions) {
        return null;
    }
    return (
        <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
            {filters && cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: 'button',
            })}
            {permissions.includes("buildings.create") &&
                <CreateButton basePath={basePath} label="Crear" />
            }
            {permissions.includes("buildings.export") &&
                <ExportButton
                    label="Exportar csv"
                    disabled={total === 0}
                    resource={resource}
                    sort={currentSort}
                    filterValues={filterValues}
                    maxResults={maxResults}
                />
            }
            {/* Add your custom actions */}
        </TopToolbar>
    );
};

const BuildingTitle = ({ record, optionTitle }) => {
    if (optionTitle) {
        return ""
    }
    return <span>Edificio - {record ? `${record.address}` : ''}</span>;
};

function parseFloat2(texto) {
    return parseFloat(texto)
}

export const MyMapComponent = withScriptjs(withGoogleMap(({ isMarkerShown, record }) =>
    <GoogleMap
        defaultZoom={15}
        googleMapURL="https://maps.googleapis.com/maps/api/js?key=12&v=3.exp&libraries=geometry,drawing,places"
        defaultCenter={{ lat: parseFloat2(record.lat), lng: parseFloat2(record.lng) }}>
        {isMarkerShown && <Marker position={{ lat: parseFloat2(record.lat), lng: parseFloat2(record.lng) }} />}
    </GoogleMap>))

export const BuildingList = props => {
    const permissions = usePermissions().permissions;
    if (!permissions) {
        return null;
    }
    return (
        <List filters={<BuildingFilter />} {...props} actions={<ListActions />} >
            <Datagrid rowClick="show">
                <ShowButton label="Ver" />
                <TextField source="id" />
                <TextField source="address" label='Dirección' />
                {(permissions.includes("cost_centers.list")) &&
                    <ReferenceField label="Centro de costo" source="costId" reference="cost_centers" link="show">
                        <FunctionField render={record => `${record.name}`} />
                    </ReferenceField>
                }
            </Datagrid>
        </List>
    )
};

const BuildingShowActions = ({ basePath, data, resource, edit = false, f = false }) => {
    const permissions = usePermissions().permissions;
    if (!permissions) {
        return null;
    }
    if ((edit || f) && permissions.includes("buildings.edit")) {
        return (
            <TopToolbar>
                {(edit) ? <EditButton basePath={basePath} record={data} label="Editar edificio" /> : null}
            </TopToolbar>
        )
    }
    return (<p></p>)
};

export const BuildingShow = props => {
    const [width, setWindowWidth] = useState(0)

    useEffect(() => {

        updateDimensions();

        window.addEventListener("resize", updateDimensions);
        return () =>
            window.removeEventListener("resize", updateDimensions);
    }, [])
    const updateDimensions = () => {
        const width = window.innerWidth
        setWindowWidth(width)
    }

    const responsive = {
        web: width > 1023
    }

    const permissions = usePermissions().permissions;
    if (!permissions) {
        return null;
    }

    return (
        <div>
            <div style={(responsive.web) ? styles.div1 : styles.div1Mobile}>
                <Show title={<BuildingTitle />} actions={<BuildingShowActions edit={true} />} {...props}>
                    <SimpleShowLayout >
                        <TextField source="id" label="Identificador" />
                        <TextField source="address" label='Dirección' />
                        <TextField source="lat" label='Latitud' />
                        <TextField source="lng" label='Longitud' />
                        {(permissions.includes("cost_centers.list")) &&
                            <ReferenceField label="Centro de costo" source="costId" reference="cost_centers" link="show">
                                <FunctionField render={record => `${record.name}`} />
                            </ReferenceField>
                        }
                        <MyMapComponent {...props} isMarkerShown={true}
                            googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyBItoupASwAy2-WBm0qfZLkAYbT5nniIv8&v=3.exp&libraries=geometry,drawing,places"
                            loadingElement={<div style={{ height: `100%` }} />}
                            containerElement={<div style={{ position: "relative", height: `250px`, width: `100%`, paddingTop: `20px` }} />}
                            mapElement={<div style={{ height: `100%` }} />}
                        />
                    </SimpleShowLayout>
                </Show>
            </div>
            <div style={(responsive.web) ? styles.div2 : styles.div2Mobile}>
                {(permissions.includes("machines.list")) &&
                    <Show title={<BuildingTitle optionTitle={true} />} actions={<BuildingShowActions />} {...props}>
                        <SimpleShowLayout>
                            <AddMachineButton />
                            <ReferenceManyField target="buildingId" label='Máquinas del edificio' reference="machines" link="show">
                                <Datagrid rowClick="show">
                                    <FunctionField label="Código" render={record => `${record.code}`} link="show" />
                                    <FunctionField label="Tipo de máquina" render={record => `${record.type[0].toUpperCase() + record.type.slice(1)}`} link="show" />
                                    <FunctionField label="Origen" render={record => `${record.secondType[0].toUpperCase() + record.secondType.slice(1)}`} link="show" />
                                    <FunctionField label="Estado" render={record => {
                                        if (record.valid === 'true') {
                                            return 'Activa';
                                        } else {
                                            if (record.repair === 'true' || record.repair === true) {
                                                return 'En reparación';
                                            }
                                        }
                                        return 'Inactiva';
                                    }} link="show" />
                                    <FunctionField render={record => {
                                        if (record.lastStart) {
                                            const date = Date.parse(record.lastStart);
                                            let numero = date;
                                            numero += record.lastDuration * 60000;
                                            const now = new Date();
                                            const diff = numero - now.getTime();
                                            const diffMinutes = diff / (1000 * 60);
                                            if (0 < diffMinutes && diffMinutes < 10) {
                                                return "Por terminar"
                                            } else if (numero > now.getTime()) {
                                                return "Ocupada"
                                            } else {
                                                return "Disponible"
                                            }
                                        }
                                    }} label='Actividad' link="show" />
                                    <FunctionField render={record => {
                                        if (record.valid === 'false' && record.repair === false) {
                                            return <EmptyCircleIcon style={{ color: 'black' }} />
                                        }
                                        if (record.valid === 'false' && record.repair === true) {
                                            return <CircleIcon style={{ color: 'black' }} />
                                        }
                                        if (record.lastConnection) {
                                            const date = Date.parse(record.lastConnection);
                                            let numero = date;
                                            const now = new Date();
                                            const diff = numero - now.getTime();
                                            const diffMinutes = Math.abs(diff / (1000 * 60));
                                            if (5 < diffMinutes && diffMinutes < 10) {
                                                return <CircleIcon style={{ color: 'yellow' }} />
                                            } else if (60 > diffMinutes && diffMinutes > 9) {
                                                return <CircleIcon style={{ color: 'red' }} />
                                            } else if (diffMinutes >= 60) {
                                                return <p><CircleIcon style={{ color: 'red' }} /><CircleIcon style={{ color: 'red' }} /></p>
                                            } else {
                                                return <CircleIcon style={{ color: 'green' }} />
                                            }

                                        } else {
                                            return <p><CircleIcon style={{ color: 'red' }} /><CircleIcon style={{ color: 'red' }} /></p>
                                        }
                                    }} label='Internet' link="show" />
                                    <FunctionField render={record => {
                                        if (record.lastConnection) {
                                            const date = Date.parse(record.lastConnection);
                                            let numero = date;
                                            const now = new Date();
                                            // calculates amout of hours since record.lastConnection
                                            const diff = numero - now.getTime();
                                            const diffHours = Math.abs(diff / (1000 * 60 * 60));
                                            if (diffHours.toFixed(1) > 0.5) {
                                                return diffHours.toFixed(1);
                                            }
                                        }
                                        return "";
                                    }} label='Horas desde última conexión' />
                                </Datagrid>
                            </ReferenceManyField>
                        </SimpleShowLayout>
                    </Show>
                }
                {(permissions.includes("transactions.list")) &&
                    <Show title={<BuildingTitle optionTitle={true} />} actions={<BuildingShowActions />} {...props}>
                        <SimpleShowLayout>
                            <RefreshButton label="Buscar transacciones" />

                            <ArrayField source="transactions" label="Transacciones (se muestran las últimas 25 transacciones)" style={styles.table} fieldKey="transactionId" >
                                <Datagrid>
                                    <TextField source="amount" label="Monto" />
                                    <NumberField source="transactionId" label="Id" />
                                    <ReferenceField source="machineId" label='Máquina' reference="machines">
                                        <FunctionField label="Máquina" render={record => record.code} link="show" />
                                    </ReferenceField>
                                    <TextField source="createdAt" label="Fecha" />
                                </Datagrid>
                            </ArrayField>
                            <button onClick={() => props.history.push(`/transactions?page=1&perPage=25&filter={"buildingId":"${props.id}"}`)}>Mostrar más transacciones</button>

                        </SimpleShowLayout>
                    </Show>
                }
            </div>
        </div>
    )
};

const BuildingFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Buscar" source="q" alwaysOn />
    </Filter>
);

export const BuildingCreate = props => {
    const permissions = usePermissions().permissions;
    if (!permissions) {
        return null;
    }
    if (!permissions.includes("cost_centers.list")) {
        return <Redirect to="/401" />
    }
    return (
        <Create {...props}>
            <SimpleForm submitOnEnter={false}>
                <TextInput source="address" label='Dirección' />
                <TextInput source="lat" label='Latitud' />
                <TextInput source="lng" label='Longitud' />
                {(permissions.includes("cost_centers.list")) &&
                    <ReferenceInput validate={[required()]} source="costId" label='Centro de costo' reference="cost_centers" perPage={200}
                        sort={{ field: 'name', order: 'ASC' }}
                    >
                        <SelectInput optionText={record => `${record.name}`} />
                    </ReferenceInput>
                }
            </SimpleForm>
        </Create>
    )
};

export const BuildingEdit = props => {
    const permissions = usePermissions().permissions;
    if (!permissions) {
        return null;
    }
    if (!permissions.includes("cost_centers.list")) {
        return <Redirect to="/401" />
    }
    return (
        <Edit {...props}>
            <SimpleForm submitOnEnter={false} toolbar={<BuildingEditToolbar />}>
                <TextInput source="address" label='Dirección' />
                <TextInput source="lat" label='Latitud' />
                <TextInput source="lng" label='Longitud' />
                {(permissions.includes("cost_centers.list")) &&
                    <ReferenceInput validate={[required()]} source="costId" label='Centro de costo' reference="cost_centers" perPage={200}
                        sort={{ field: 'name', order: 'ASC' }}
                    >
                        <SelectInput optionText={record => `${record.name}`} />
                    </ReferenceInput>
                }
            </SimpleForm>
        </Edit>
    )
};

const BuildingEditToolbar = props => (
    <Toolbar {...props} >
        <SaveButton />
    </Toolbar>
);
